import { Button } from 'antd';
import React, { ReactNode, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import update from 'immutability-helper';
import {
  deleteLayoutModules,
  updateLayoutModulesIndexes,
} from '../store/config';
import { CgTrash } from 'react-icons/cg';
import { FaArrowDown, FaArrowUp, FaEdit, FaPlus } from 'react-icons/fa';
import './editComponent.less';
import { RootState } from '../store/store';
import { useLocation, useSearchParams } from 'react-router-dom';
import {ModuleErrorBoundary} from '../components/ErrorBoundary/ModuleErrorBoundary';

interface Props {
  children: ReactNode;
  layoutSection: string;
  instance: string;
  pageId: string;
  pageComponents: string[];
  moduleName: string;
  index: string;
  setSelectedInstance: React.Dispatch<React.SetStateAction<string | null>>;
  selectedInstance: string | null;
  layout: string;
  allowOnlyEdit?: boolean;
  isEditAllowed: boolean;
  config: any;
}

const EditLayoutComponent = ({
  children,
  layoutSection,
  pageId,
  pageComponents,
  moduleName,
  instance,
  index,
  setSelectedInstance,
  selectedInstance,
  layout,
  allowOnlyEdit = true,
  isEditAllowed = false,
  config,
}: Props) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isEditMode = searchParams.get('editMode') === 'true' && isEditAllowed;
  const brokenModule = !moduleName;
  const disableDeleteAction = !brokenModule;

  const isClickingDisabled =
    searchParams.get('editMode') === 'true' && !isEditAllowed;
  // const siteConfig = useSelector((data: RootState) => data.config.config);
  const {
    config: { layouts },
    translations,
  } = useSelector((data: RootState) => data.config);

  const handleEditOpen = (data: {
    instance: string;
    moduleName: string;
    layoutSection: string;
    pageId: string;
    index: string;
  }) => {
    setSelectedInstance(data.instance);
    window.parent.postMessage(
      {
        type: 'EditLayout',
        message: data,
      },
      '*'
    );
  };

  const moveModule = ({
    dragIndex,
    hoverIndex,
  }: {
    dragIndex: any;
    hoverIndex: any;
  }) => {
    window.parent.postMessage(
      {
        type: 'UpdateWhiteLabelLayoutModulesIndexes',
        dragIndex,
        hoverIndex,
        layoutName: layout,
        layoutSection,
      },
      '*'
    );

    dispatch(
      updateLayoutModulesIndexes({
        dragIndex,
        hoverIndex,
        layoutName: layout,
        layoutSection,
      })
    );
  };

  const handleDeleteLayoutModule = (instanceToDelete: string) => {
    window.parent.postMessage(
      {
        type: 'DeleteLayout',
        layoutName: layout,
        instanceToDelete,
        layoutSection,
      },
      '*'
    );
    dispatch(
      deleteLayoutModules({
        moduleToDelete: instanceToDelete,
        layoutName: layout,
        layoutSection,
      })
    );
  };

  const handleAddLayoutModule = ({
    i,
    section,
  }: {
    i: number;
    section: string;
  }) => {
    window.parent.postMessage(
      { type: 'AddLayout', message: { index: i, layoutSection: section } },
      '*'
    );
  };
  const location = useLocation();

  return (
    <div
      className={`EDIT-LAYOUT ${isEditMode ? 'EDIT' : ''} ${
        allowOnlyEdit ? 'ONLY-EDIT' : ''
      } ${selectedInstance === instance ? 'EDIT-MODE-ON' : ''} ${
        isClickingDisabled ? 'IS_CLICKING_DISABLED' : ''
      }`}
      onClick={() => {
        isEditMode &&  handleEditOpen({
          instance,
          moduleName,
          layoutSection,
          pageId,
          index,
        });
      }}
      // draggable={false}
    >
      {isEditMode && (
        <div className="EDIT-BUTTON">
          {!allowOnlyEdit && (
            <Button
              className="add-btn-top"
              icon={<FaPlus />}
              onClick={() =>
                handleAddLayoutModule({
                  i: Number(index),
                  section: layoutSection,
                })
              }
            >
              Add Layout Module on Top
            </Button>
          )}

          <div>
            {!allowOnlyEdit && (
              <div className="arrows-wrapper">
                <FaArrowUp
                  className={`button ${Number(index) !== 0 ? '' : 'disabled'}`}
                  size={18}
                  onClick={() => {
                    Number(index) !== 0 &&
                      moveModule({
                        dragIndex: Number(index) - 1,
                        hoverIndex: Number(index),
                      });
                  }}
                />
                <FaArrowDown
                  className={`button ${
                    layouts[layout][layoutSection]?.length - 1 !== Number(index)
                      ? ''
                      : 'disabled'
                  }`}
                  size={18}
                  onClick={() => {
                    layouts[layout][layoutSection]?.length - 1 !==
                      Number(index) &&
                      moveModule({
                        dragIndex: Number(index),
                        hoverIndex: Number(index) + 1,
                      });
                  }}
                />
              </div>
            )}

            {moduleName && (
              <div
                onClick={() => {
                  handleEditOpen({
                    instance,
                    moduleName,
                    layoutSection,
                    pageId,
                    index,
                  });
                }}
                className="edit"
              >
                <FaEdit size={18} className="button" />
              </div>
            )}

            {(!allowOnlyEdit || brokenModule) && (
              <div
                className={`delete ${
                  disableDeleteAction ? 'IS_CLICKING_DISABLED disabled' : ''
                }`}
                onClick={() => {
                  if (disableDeleteAction) {
                    return;
                  }
                  handleDeleteLayoutModule(instance);
                }}
              >
                <CgTrash size={18} className="button" />
              </div>
            )}
          </div>

          {!allowOnlyEdit && (
            <Button
              className="add-btn-bottom"
              icon={<FaPlus />}
              onClick={() =>
                handleAddLayoutModule({
                  i: Number(index) + 1,
                  section: layoutSection,
                })
              }
            >
              Add Layout Module on Bottom
            </Button>
          )}
        </div>
      )}
      <ModuleErrorBoundary t={translations}>
        {children}
      </ModuleErrorBoundary>
    </div>
  );
};

export default EditLayoutComponent;
